import { render, staticRenderFns } from "./PaymentCancel.vue?vue&type=template&id=6815cd62&scoped=true"
import script from "./PaymentCancel.vue?vue&type=script&lang=js"
export * from "./PaymentCancel.vue?vue&type=script&lang=js"
import style0 from "./PaymentCancel.vue?vue&type=style&index=0&id=6815cd62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6815cd62",
  null
  
)

export default component.exports